module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7499217c0e062f21abee242378b8bad9.png";